"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    stepTitle: {
        id: 'registration.address.stepTitle',
        defaultMessage: 'Address',
        description: 'Registration address step title',
    },
    title: {
        id: 'registration.address.title',
        defaultMessage: 'Address',
        description: 'Registration address title',
    },
    description: {
        id: 'registration.address.description',
        defaultMessage: 'Please enter your address.',
        description: 'Registration address description',
    },
    alphanumericValidation: {
        id: 'general.alphanumericValidation',
        defaultMessage: 'Please only use alphanumeric characters.',
        description: 'Alphanumeric validation',
    },
    alphaCharactersValidation: {
        id: 'general.alphaCharactersValidation',
        defaultMessage: 'Please use alphabetic characters.',
        description: 'Alpha characters validation',
    },
});
exports.default = messages;
